import { Mui } from '@osu/react-ui';
import { useStore } from "react-redux";
import { graphqlApi } from "../../../services/graphql/api";

export default function MenuDialogBase({ apiCall, buttons, extraContent, menuItemAndClose = {}, result }) {
    const store = useStore();
    const { menuItem = {}, close } = menuItemAndClose;
    const cancelOrCloseLabel = result?.isSuccess ? "Close" : "Cancel";
    const closeVariant = result?.isSuccess ? "contained" : "none";
    
    const closeAndRefreshIfNoLoad = () => closeAndRefresh(result.isLoading);
    function closeAndRefresh(isLoading) { // Refresh application details if it makes sense
        
        if (isLoading) { return; } // Prevent mid-apiCall closings
        if (result?.isSuccess ) { store.dispatch(graphqlApi.util.invalidateTags(['getApplicationDetails'])); }
        close();
    }
    
    return (
        <Mui.Dialog
            aria-describedby="alert-dialog-description"
            aria-labelledby="alert-dialog-title"
            aria-live="polite"
            fullWidth maxWidth="sm" // Necessary for shorter messages
            onBackdropClick={closeAndRefreshIfNoLoad}
            open={true}
        >
            <AlertMessage result={result} />

            <Mui.DialogTitle tabIndex={0} id="alert-dialog-title">{menuItem.label}</Mui.DialogTitle>
            
            <Mui.DialogContent>
                <Mui.DialogContentText tabIndex={0} id="alert-dialog-description">{menuItem.message}</Mui.DialogContentText>
                
                {extraContent}
            </Mui.DialogContent>
            
            <Mui.DialogActions className="padding-2">
                <Mui.Button disabled={result?.isLoading} onClick={closeAndRefreshIfNoLoad} size="small" variant={closeVariant} sx={{ minWidth: "6em" }}>{cancelOrCloseLabel}</Mui.Button>
                {buttons?.map((button, index) => <DialogButton apiCall={apiCall} key={index} button={button} result={result} />) ?? <></> }
            </Mui.DialogActions>
        </Mui.Dialog>
    );
}

function AlertMessage({ result = {} }) {
    const { data, error, isError, isLoading, isSuccess } = result;
    if (isLoading || !(isError || isSuccess)) { return <></>; }
    
    // Check if lambda response includes a type field (info, success, error), otherwise default to success
    const severity = isError ? "error" : (data?.type ?? "success");
    let message = isError ? (error.message ?? "Encountered error with last request.") : (data?.status ?? "Success");
    
    return (
        <Mui.Alert aria-live="polite" autoFocus severity={severity} sx={theme => theme.applyStyles("dark", { backgroundColor: "#666" })}>
            <Mui.Typography>{message}</Mui.Typography>
        </Mui.Alert>
    );
}

function DialogButton({ apiCall, button, result = {} }) {
    const { isLoading, isSuccess } = result;
    let { label, variables, variablesFn = () => {} } = button;
    if (isSuccess || !label) { return <></>; } // Hide button if successful
    
    variables = variables ?? variablesFn(); // Doesn't exist? Pull dynamically
    
    async function apiCallFn() { apiCall(variables); }
    
    return (
        <Mui.Button
            id={label}
            disabled={isLoading || button.isDisabled}
            onClick={apiCallFn}
            size="small"
            style={{ marginRight: "0.5rem", minWidth: "6em" }}
            variant="contained">
                { isLoading && <Mui.CircularProgress size={20} style={{ float: "left" }} className="margin-right-2" /> }
                {label}
        </Mui.Button>
    );
}